/**
 * Toast.ts — Reusa #swAviso pra mostrar mensagens curtas (capturas, erros).
 *
 * Refator de tres.php:1594-1603.
 */

const DURACAO_MS = 2200;

export class Toast {
  private readonly elemento: HTMLElement;
  private timer: number | null = null;

  constructor() {
    const el = document.getElementById('swAviso');
    if (!el) throw new Error('Elemento #swAviso nao encontrado no DOM');
    this.elemento = el;
  }

  mostrar(texto: string, duracao = DURACAO_MS, tom: 'normal' | 'ruim' | 'bom' = 'normal'): void {
    this.elemento.textContent = texto;
    this.elemento.classList.toggle('ruim', tom === 'ruim');
    this.elemento.classList.toggle('bom', tom === 'bom');
    this.elemento.classList.add('visivel');
    if (this.timer !== null) clearTimeout(this.timer);
    this.timer = window.setTimeout(() => {
      this.elemento.classList.remove('visivel');
    }, duracao);
  }
}
